import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './TestHistory.css'
import LoadingScreen from '../components/LoadingScreen'

const TestHistory = () => {
  const [testHistory, setTestHistory] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const history = useHistory()

  useEffect(() => {
    let isMounted = true

    const token = localStorage.getItem('access_token')
    if (!token) {
      history.push('/login')
      return
    }

    const fetchTestHistory = async () => {
      try {
        const token = localStorage.getItem('access_token')
        const response = await fetch('/api/student/test-history', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (response.ok) {
          const data = await response.json()
          if (isMounted) {
            setTestHistory(data.test_history || [])
          }
        } else {
          if (isMounted) {
            setError('Failed to load test history')
          }
        }
      } catch (err) {
        if (isMounted) {
          setError('Network error')
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchTestHistory()

    return () => {
      isMounted = false
    }
  }, [history])

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'completed':
        return 'status-completed'
      case 'in_progress':
        return 'status-in-progress'
      case 'flagged':
        return 'status-flagged'
      default:
        return 'status-default'
    }
  }

  const handleViewResult = (attemptId) => {
    history.push(`/test-details/${attemptId}`)
  }

  if (loading) {
    return <LoadingScreen message="Loading Test History" />
  }

  return (
    <div className="test-history-container">
      <header className="page-header">
        <h1>Test History</h1>
        <button onClick={() => history.push('/student-dashboard')} className="back-button">
          Back to Dashboard
        </button>
      </header>

      {error && <div className="error-message">{error}</div>}

      <div className="test-history-content">
        {testHistory.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📚</div>
            <h3>No Test History</h3>
            <p>You haven't taken any tests yet</p>
            <button onClick={() => history.push('/available-tests')} className="primary-btn">
              Browse Available Tests
            </button>
          </div>
        ) : (
          <div className="history-table-container">
            <table className="history-table">
              <thead>
                <tr>
                  <th>Test Name</th>
                  <th>Date Taken</th>
                  <th>Score</th>
                  <th>Status</th>
                  <th>Violations</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {testHistory.map((attempt) => (
                  <tr key={attempt.id}>
                    <td className="test-name">{attempt.test_title}</td>
                    <td>{new Date(attempt.created_at).toLocaleDateString()}</td>
                    <td className="score-cell">
                      <span className={attempt.percentage >= 60 ? 'score-pass' : 'score-fail'}>
                        {attempt.percentage}%
                      </span>
                    </td>
                    <td>
                      <span className={`status-badge ${getStatusBadgeClass(attempt.status)}`}>
                        {attempt.status}
                      </span>
                    </td>
                    <td className="violations-cell">
                      {attempt.violation_count || 0}
                    </td>
                    <td>
                      <button
                        onClick={() => handleViewResult(attempt.id)}
                        className="view-btn"
                      >
                        View Result
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default TestHistory
